import { createFileRoute } from '@tanstack/react-router'

import { LoadingSpinner } from '@/components/LoadingSpinner'
import { PageContent } from '@/components/page-content'
import { PageMenu } from '@/components/page-menu'
import { Skeleton } from '@/components/ui/skeleton'
import { tagsByIdQueryOptions } from '@/features/tags/queries'
import { ApplicantsTagPage } from '@/modules/user/presentation/pages/applicants/ApplicantsTagPage'
import { paginationQueryParamsSchema } from '@/shared/schemas/pagination'

export const Route = createFileRoute('/_authenticated/applicants/tags/$tagId')({
  component: ApplicantsTagPage,
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `Applicants : Tags - ${loaderData}`,
      },
    ],
  }),
  loader: async ({ context: { queryClient }, deps, params: { tagId } }) => {
    const response = await queryClient.ensureQueryData(tagsByIdQueryOptions(tagId, deps))
    return response.name
  },
  loaderDeps: ({ search: { itemsPerPage, page } }) => ({ itemsPerPage, page }),
  pendingComponent: () => (
    <>
      <PageMenu>
        <Skeleton className="h-6 w-16" />
        <Skeleton className="h-6 w-56" />
      </PageMenu>
      <PageContent>
        <LoadingSpinner />
      </PageContent>
    </>
  ),
  validateSearch: paginationQueryParamsSchema,
})
